  export const liveChannelCreateObj = {
    // Trigger conditions (used by initiator)
    trigger: {
      path: '/api2/cloudslicer/jobs/create', // API path to match
      successPath: 'node.response.status',   // Path to success status field
      successValue: 'success',               // Expected success value
      errorPath: 'error',                    // Path to error code in response
      errorValue: 0,                         // Expected error value for success
      requiresFields: ['job.id'],            // Fields that must exist to proceed
    },
    
    // Tracking configuration (shared between initiator and tracker)
    tracking: {
      idPath: 'job.id',                      // Path to tracking ID in response
      targetStates: ['done', 'error'],       // States that indicate completion
    },
    
    // Status and callback functions (used by initiator)
    callbacks: {
      setProcessRunning: null,               // Status management function (set at runtime)
      onProgressCallback: null,              // Progress update function (set at runtime)
      updateResults: null,                   // Results update function (set at runtime)
    },
    
    // Resources needed (set at runtime)
    resources: {
      credentials: null,                     // Auth credentials
      abortControllerRef: null               // Abort controller reference
    },
    
    // API configuration (used by tracker)
    api: {
      path: '/api2/cloudslicer/jobs/get',    // API endpoint path
      method: 'GET',                         // HTTP method
      rootUrl: 'https://services.uplynk.com', // Base API URL
    },
    
    // Response field mappings (used by tracker)
    response: {
      statePath: 'data.job.state',           // Path to job state in response
      progressMapping: {                     // Fields to extract for progress updates
        state: 'data.job.state',
        progress: 'data.job.progress',
        progress_percent: 'data.job.progress_percent'
      },
      completionMapping: {                   // Fields to extract on completion
        playerURL: 'https://content.uplynk.com/{data.job.asset}.m3u8'
      }
    },
    
    // Job states configuration (used by tracker)
    states: {
      completeStates: ['done'],              // States that indicate completion
      errorStates: ['error']                 // States that indicate errors
    },
    
    // Polling behavior (used by tracker)
    polling: {
      maxAttempts: 100,                      // Maximum polling attempts
      intervalMs: 5000,                      // Base polling interval in milliseconds
      timeoutMs: 10 * 60 * 1000,             // Overall timeout (10 minutes)
      backoff: {
        enabled: true,
        factor: 0.5,
        maxMs: 30000
      }
    }
  };


  // const cloudSlicerConfig = {
  //   trigger: {
  //     path: '/api2/cloudslicer/jobs/create',
  //     successPath: 'node.response.status',
  //     successValue: 'success',
  //     errorPath: 'error',
  //     errorValue: 0,
  //     requiresFields: ['job.id'],
  //   },
  //   tracking: {
  //     idPath: 'job.id',
  //     targetStates: ['done', 'error'],
  //     trackingFunction: trackCloudSlicerJobStatus,
  //     progressMapping: {
  //       state: 'response.data.job.state',
  //       progress: 'response.data.job.progress',
  //       progress_percent: 'response.data.job.progress_percent'
  //     },
  //     completionMapping: {
  //       playerURL: 'data.job.asset',
  //     },
  //   },
  //   callbacks: {
  //     setProcessRunning: setIsCloudProcessRunning,
  //     onProgressCallback: appendUplynkJobState,
  //     updateResults: updateSharedParams,
  //   },
  //   resources: {
  //     credentials: credentials,
  //     abortControllerRef: sharedAbortControllerRef,
  //   }
  // };
